import { render, staticRenderFns } from "./UserManagementInstructions.vue?vue&type=template&id=2f9ddd3f&"
import script from "./UserManagementInstructions.vue?vue&type=script&lang=js&"
export * from "./UserManagementInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports